import { form } from '../formState'
import { useTexts } from '../hooks/useTexts'
import { OrdersType } from './OrdersType'

export function NoteField() {
  const texts = useTexts()

  const {
    field: { value: isChecked },
  } = form.useFormField('includeNoteChecked')

  const {
    meta: { submitting, disabled },
  } = form.useFormMeta()
  const formDisabled = submitting || disabled

  return (
    <form.Fieldset spacing={1}>
      <form.Checkbox
        name="includeNoteChecked"
        label={texts.note}
        testId="driver-assistance-form-note-field"
        disabled={formDisabled}
        validateOn="blur change"
      />
      {isChecked && <OrdersType name="includeNote" disabled={formDisabled} />}
    </form.Fieldset>
  )
}
